import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { NkCardListItemDetails } from '@nk/ui-lib';
import { LOADING_STATE_HANDLER_SERVICE_TOKEN } from '@nk/utils-lib';
import { ScreeningCaseCardListItem } from '../screening-case-card-list.utils';
import { ScreeningAdverseMediaCardListComponent } from '../../screening-adverse-media-card-list/screening-adverse-media-card-list.component';
import { ScreeningCaseTableComponent } from '../../screening-case-table/screening-case-table.component';

@Component({
  selector: 'nk-screening-case-card-list-details',
  imports: [ScreeningCaseTableComponent, ScreeningAdverseMediaCardListComponent],
  templateUrl: './screening-case-card-list-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScreeningCaseCardListDetailsComponent implements NkCardListItemDetails<ScreeningCaseCardListItem> {
  @Input() public entity!: ScreeningCaseCardListItem;
  @Input() public highlightText?: string;
  public isPrintVersion = !!inject(LOADING_STATE_HANDLER_SERVICE_TOKEN, { optional: true });
}
